import plur from 'plur'
import {memo} from 'react'

import {restApi} from '../../../../services/rest'
import type {BuildId} from '../../../../types'
import {
  getArtifactInfo,
  getDownloadedArtifactsArg,
} from '../../../pages/BuildPage/DependenciesTab/ArtifactDependencies/ArtifactDependencies.utils'

type Props = {
  from: BuildId
  to: BuildId
  className?: string
}

function ArtifactChangeFiles({from, to, className}: Props) {
  const {countArtifacts} = restApi.endpoints.getBuild.useQuery(getDownloadedArtifactsArg(to), {
    selectFromResult: ({data}) => ({
      countArtifacts: getArtifactInfo(data, from)?.length,
    }),
  })

  return (
    <span className={className}>
      {countArtifacts == null ? 'Loading...' : `${countArtifacts} ${plur('file', countArtifacts)}`}
    </span>
  )
}

export default memo<Props>(ArtifactChangeFiles)
